import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';

import {
    HTTP_STATUS_CODE_CONFLICT,
    HTTP_STATUS_CODE_FORBIDDEN,
    HTTP_STATUS_CODE_UNAUTHORIZED,
} from '@/constants';
import useAuthStore from '@/stores/useAuthStore';
import useDialogStore from '@/stores/useDialogStore';

export const initAxios = () => {
    axios.defaults.validateStatus = (): boolean => true;
    axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
        const authStore = useAuthStore();
        const token = await authStore.getToken();

        if (token) {
            config.headers.Authorization = 'Bearer ' + token;
        }

        return config;
    });

    axios.interceptors.response.use(
        async (response: AxiosResponse<unknown>): Promise<AxiosResponse<unknown>> => {
            if (response?.status === HTTP_STATUS_CODE_FORBIDDEN) {
                useDialogStore().showUnauthorizedAccessDialog = true;
                return response;
            }

            if (
                !response?.status ||
                response.status === HTTP_STATUS_CODE_UNAUTHORIZED ||
                response.status === HTTP_STATUS_CODE_CONFLICT
            ) {
                useAuthStore().logout(); // Only use auth store when needed, not on every response
            }
            return response;
        }
    );
};
